export var RESTRICTED_ASCENDANT_ATTRIBUTE = 'data-tolgee-restricted';
export var TOLGEE_ATTRIBUTE_NAME = '_tolgee';
export var TOLGEE_TARGET_ATTRIBUTE = '_tolgee-target';
export var TOLGEE_WRAPPED_ONLY_DATA_ATTRIBUTE = 'data-tolgee-key-only';
